import { Link } from "react-router-dom";
import { PORTRAIT_URL, PODIUM_URL, RIBBON_URL, PARK_URL, SPEAKING_GALLERY, MENTORSHIP_GALLERY, COURT_PORTRAIT_URL, COURT_PORTRAIT_VIDEO } from "@/lib/assets";

export default function About() {
  return (
    <div>
      <section className="bg-cream border-b border-gold-light">
        <div className="brand-container py-20 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="brand-eyebrow mb-4">Meet Judge Auntie™</div>
            <h1 className="brand-h1">The Honorable<br/>Eileen A. Olds (Ret.)</h1>
            <p className="brand-lede mt-6">
              A retired judge with a courtroom's discipline and a family kitchen's warmth.
            </p>
          </div>
          <div className="lg:col-span-7">
            <img src={PORTRAIT_URL} alt="Judge Eileen Olds" className="w-full h-[520px] object-cover rounded-lg border border-gold-light" />
          </div>
        </div>
      </section>

      <section className="bg-cream">
        <div className="brand-container py-20 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-6 brand-body">
            <p>
              Judge Eileen Anita Olds is a proud graduate of Indian River High School, Chesapeake, Virginia. She received a
              Bachelor of Arts degree with distinction from the University of Virginia, and a Juris Doctorate degree from
              William and Mary Law School. Her exceptional legal career began as a private practitioner, specializing in
              state and federal criminal defense, and domestic relations law. In addition, she was appointed by two
              Attorneys General to represent the State Department of Highways and Transportation, and served as a
              Divorce Commissioner, and Commissioner in Chancery prior to her tenure on the bench.
            </p>
            <p>
              Judge Olds' <b className="text-plum">1995 appointment to the bench was historical</b> in that she became
              the first woman and African-American judge in the First Judicial District in Virginia.
            </p>
            <p>
              Prior to her judicial appointment, Judge Olds served as President of the South Hampton Roads Bar Association,
              and on the Virginia Commission for Women and Minorities in the Legal Profession.
            </p>
            <p>
              Her civic and professional affiliations include Delta Sigma Theta Sorority, Inc., the Links, Inc., and the
              Girl Friends, Inc. She is co-founder of the Friends of Hampton Roads, Inc., and a founder of the
              Williamsburg, VA Alumnae Chapter of Delta Sigma Theta Sorority. She has consistently been a member of
              local, state and national bar and judicial organizations and served on the Executive Board of the National
              Bar Association Judicial Council, and on the Executive Committee of the District Court Judges in Virginia.
            </p>
            <p>
              In 2007, she was elected <b className="text-plum">President of the American Judges Association (AJA)</b> —
              the largest independent association of judges throughout the United States and Canada, and remains the
              first and only Virginian to hold the position since AJA's inception in 1959. She was inducted into Omicron
              Delta Kappa Honor Society as a Distinguished William and Mary Alumna. She is also the recipient of the
              Douglas Morton Alumni Service Award from the College of William and Mary.
            </p>
            <p>
              Previously, she extended her community service on the Board of Directors of Job Corps, Inc., the Conference
              of Chief Justice's Best Practices Institute, and on the Virginia Task Force on Gangs and Youth Violence. In
              addition to her traditional court duties, Judge Olds was the visionary behind the implementation of a{" "}
              <b className="text-plum">Truancy Court</b>, designed to foster the importance of education. She has been
              recognized by numerous organizations, churches, and educational institutions for her advocacy and dedication
              to youth.
            </p>
            <p>
              Judge Olds is the recipient of many awards and citations from distinguished organizations including Delta
              Sigma Theta Sorority, Inc., Phi Delta Kappa Sorority, Inc., and Zeta Phi Beta Sorority, Inc.; the United
              Negro College Fund; the Conference of Minority Public Administrators; the American Judges Association;
              USAA; the Virginia Desert Conference of Courts; Daughters of Isis; the City of Chesapeake; Tidewater
              Community College; and was previously designated as a Tazewell-Taylor Jurist-in-Residence at William and
              Mary Law School. She has been awarded the Thurgood Marshall Award from the National Bar Association
              Judicial Council, the Outstanding Jurist Award from the National Association of Women Judges, the Raymond
              Pace Alexander Award from the National Bar Association, the Woman of Achievement Award from the Miss
              Chesapeake/Miss America Pageant, and the Outstanding Virginian Award from the American Legion Auxiliary.
              She has also been honored and recognized for her public service by the Norfolk (VA) Navy Public Works
              Center, the United States Navy Military Sealift Command, the Atlantic Fleet's Commander Combat Logistics
              Group, and as a member of the Council on Legal Education's Hall of Fame.
            </p>
            <p>
              Following <b className="text-plum">twenty-four years of service</b>, she retired on July 1, 2019. At the
              time of her retirement, she was Chesapeake's longest serving judge. She is the author of{" "}
              <b className="text-plum italic">"Twin Expectations: raising the bar, raising expectations, raising
              children!"</b> and has been featured in other periodicals and publications.
            </p>
            <p>
              Since her retirement, she has served on the boards of WHRO Public Media, the Philanthropy Council of the
              Children's Hospital of the King's Daughters, and the Alumni Association Board of Directors at William and
              Mary Law School. She currently serves as a <b className="text-plum">recall judge by appointment of the
              Chief Justice of Virginia</b>.
            </p>

            <blockquote className="mt-8 pl-6 border-l-4 border-gold text-plum font-serif text-2xl italic leading-snug">
              In October 2021, the Chesapeake, Virginia City Council voted unanimously to name the acreage that includes
              the judicial system buildings and city hall the <span className="not-italic">JUDGE EILEEN OLDS COURTYARD PARK</span>.
            </blockquote>
          </div>
          <aside className="lg:col-span-4 space-y-6">
            <div className="editorial-card p-6">
              <div className="brand-eyebrow">On The Record</div>
              <ul className="mt-4 space-y-3 text-sm text-charcoal/80">
                <li><b className="text-plum">UVA · William &amp; Mary Law</b> — Degrees with distinction</li>
                <li><b className="text-plum">1995</b> — First woman &amp; African-American judge in VA's First Judicial District</li>
                <li><b className="text-plum">24 years</b> — Retired July 1, 2019 as Chesapeake's longest serving judge</li>
                <li><b className="text-plum">2007</b> — President, American Judges Association (first &amp; only Virginian since 1959)</li>
                <li><b className="text-plum">Recall Judge</b> — By appointment of the Chief Justice of Virginia</li>
                <li><b className="text-plum">Author</b> — <em>Twin Expectations</em></li>
                <li><b className="text-plum">Namesake</b> — Judge Eileen Olds Courtyard Park, Chesapeake, VA</li>
              </ul>
            </div>
            <Link to="/book" className="btn-primary w-full" data-testid="about-book-btn">Book Judge Auntie™ to speak</Link>
            <Link to="/press" className="btn-outline w-full" data-testid="about-press-btn">Download press kit</Link>
          </aside>
        </div>
      </section>

      {/* Mentorship — Pouring into the Next Generation */}
      <section className="bg-cream-alt border-t border-gold-light" data-testid="about-mentorship-section">
        <div className="brand-container py-20">
          <div className="brand-eyebrow">Mentorship</div>
          <h2 className="brand-h2 mt-3 mb-4">Pouring into the Next Generation.</h2>
          <p className="brand-body max-w-3xl">
            Long before the bench, and long after the gavel came down, Judge Olds has made room at the table for young
            people. From the Truancy Court she implemented in 2000 to Delta Sigma Theta youth initiatives, school visits,
            and quiet one-on-one conversations with children navigating hard seasons — mentorship has always been part of
            her calling. These are a few moments from that work.
          </p>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {MENTORSHIP_GALLERY.map((g, i) => (
              <figure key={i} className="editorial-card overflow-hidden" data-testid={`about-mentorship-${i}`}>
                <div className="aspect-[4/3] overflow-hidden bg-cream">
                  <img
                    src={g.url}
                    alt={g.caption}
                    className="w-full h-full object-cover"
                    style={g.position ? { objectPosition: g.position } : undefined}
                    loading="lazy"
                  />
                </div>
                <figcaption className="p-4 text-xs text-charcoal/70">{g.caption}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* Court Portrait + Featured Speech */}
      <section className="bg-plum text-cream border-t border-gold/40">
        <div className="brand-container py-20 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <img src={COURT_PORTRAIT_URL} alt="Official courthouse portrait of the Honorable Eileen A. Olds"
                className="w-full h-auto rounded-md shadow-2xl border border-gold/40" />
              <div className="mt-4 text-xs text-cream/60 text-center italic">
                Official portrait, Circuit Court of Chesapeake, VA
              </div>
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="brand-eyebrow !text-gold">On the Wall of the Bench</div>
            <h2 className="font-serif text-3xl md:text-4xl leading-tight text-cream mt-3">
              Her portrait now hangs<br/>in the very court she served.
            </h2>
            <p className="mt-5 text-cream/80 leading-relaxed">
              After more than two decades on the bench, Judge Olds' official oil portrait was unveiled at the
              Chesapeake courthouse — a permanent seat in the room even after retirement. Watch the ceremony
              and her remarks below.
            </p>
            <div className="mt-8 aspect-video rounded-md overflow-hidden border border-gold/40 bg-charcoal">
              <iframe src={COURT_PORTRAIT_VIDEO} title="Portrait Unveiling — The Honorable Eileen A. Olds"
                className="w-full h-full" frameBorder="0" allowFullScreen
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                data-testid="about-court-portrait-video" />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-cream-alt border-t border-gold-light">
        <div className="brand-container py-20">
          <div className="brand-eyebrow">Speaking Highlights</div>
          <h2 className="brand-h2 mt-3 mb-3">Come sit — she's been on every stage.</h2>
          <p className="brand-body max-w-2xl">Keynotes, community halls, and outdoor addresses across Virginia and beyond. A short gallery from recent speaking engagements.</p>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {SPEAKING_GALLERY.map((g, i) => (
              <figure key={i} className="editorial-card overflow-hidden" data-testid={`about-speaking-${i}`}>
                <div className="aspect-[3/4] overflow-hidden bg-cream">
                  <img
                    src={g.url}
                    alt={g.caption}
                    className="w-full h-full object-cover"
                    style={g.rotate ? { transform: `rotate(${g.rotate}deg) scale(1.35)`, transformOrigin: "center" } : undefined}
                    loading="lazy"
                  />
                </div>
                <figcaption className="p-4 text-xs text-charcoal/70">{g.caption}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-cream border-t border-gold-light">
        <div className="brand-container py-20">
          <div className="brand-eyebrow">In the Community</div>
          <h2 className="brand-h2 mt-3 mb-10">A courtyard named for her — a legacy still being written.</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <img src={PARK_URL} alt="Courtyard Park" className="rounded-lg w-full h-64 object-cover" />
            <img src={RIBBON_URL} alt="Ribbon cutting" className="rounded-lg w-full h-64 object-cover" />
            <img src={PODIUM_URL} alt="Speaking" className="rounded-lg w-full h-64 object-cover" />
          </div>
        </div>
      </section>
    </div>
  );
}
